module.exports = __webpack_public_path__ + "img/affiliate.16b0cf2d.png";